import './library/foundation';

import { SplitText } from 'gsap/SplitText';
import barba from '@barba/core';

import {
  animationEnterHideCircleLoader,
  animationEnterHero,
  animationLeaveCircleLoader,
  animationTitleEffect,
  animationParagraphEffect,
  animationParagraphBisEffect,
  animationBlockquoteEffect,
  animationListEffect,
  animationIconEffect,
  animationFeaturedLink,
  animationParallaxEffect,

} from './animations';

import { library, dom } from '@fortawesome/fontawesome-svg-core';

import {
  faEnvelope,
  faPhone,
  faHeart,
} from '@fortawesome/free-solid-svg-icons';
import {
  faFacebookSquare,
  faInstagram,
  faFacebookF,
} from '@fortawesome/free-brands-svg-icons';

import { faChevronRight } from '@fortawesome/pro-light-svg-icons';

gsap.registerPlugin(ScrollTrigger, SplitText);

library.add(
  faFacebookSquare,
  faInstagram,
  faChevronRight,
  faEnvelope,
  faPhone,
  faFacebookF,
  faHeart
);

dom.watch();

$.post(
  ajax_object.ajax_url,
  { action: 'is_user_logged_in' },
  function (isLogged) {
    if (!isLogged) {
      init();
    }
  }
);

gsap.config({
  nullTargetWarn: false,
});

$(document).foundation();

const init = () => {
  // reset loader to be invisible on page load
  gsap.set('.loader', { scale: 0 });

  // Set <body> classes for the 'next' page
  barba.hooks.beforeEnter(({ current, next }) => {
    if (current.container) {
      let nextHtml = next.html;
      let response = nextHtml.replace(
        /(<\/?)body( .+?)?>/gi,
        '$1notbody$2>',
        nextHtml
      );
      let bodyClasses = $(response).filter('notbody').attr('class');
      $('body').attr('class', bodyClasses);
    }

    if (
      next.namespace === 'home' &&
      document.querySelector('.logo-container span')
    ) {
      let elem = document.querySelector('.logo-container span');
      let parent = elem.parentNode;
      let newElement = document.createElement('h1');
      newElement.textContent = elem.textContent;
      newElement.style.cssText = elem.style.cssText;
      parent.replaceChild(newElement, elem);
    } else {
      if (document.querySelector('.logo-container h1')) {
        let elem = document.querySelector('.logo-container h1');
        let parent = elem.parentNode;
        let newElement = document.createElement('span');
        newElement.textContent = elem.textContent;
        newElement.style.cssText = elem.style.cssText;
        parent.replaceChild(newElement, elem);
      }
    }

    window.scrollTo(0, 0);
  });

  // do something before the transition starts
  barba.hooks.before(() => {
    document.querySelector('html').classList.add('is-transitioning');

    if (document.body.classList.contains('is-off-canvas-open')) {
      $('.off-canvas').foundation('close');
    }
  });

  // do something after the transition finishes
  barba.hooks.after(() => {
    document.querySelector('html').classList.remove('is-transitioning');
  });

  barba.hooks.afterLeave((data) => {
    // Update the active menu item classes
    if (data.next.url.path) {
      const activeClass = 'is-active';

      $('.menu-item.' + activeClass).each(function () {
        $(this).removeClass(activeClass);
      });

      if (data.next.url.path !== '/') {
        $(`.menu-item > a[href$="${data.next.url.path}"]`)
          .closest('.menu-item')
          .each(function () {
            $(this).addClass(activeClass);
          });
      }
    }
  });

  barba.hooks.beforeOnce(() => {
    window.scrollTo(0, 0);
  });

  barba.init({
    debug: false,
    views: [{
      namespace: 'home',
      afterEnter(data) {
        animationFeaturedLink(data.next.container);
        animationParallaxEffect(data.next.container);
      }
    }, {
      namespace: 'decouvrez-nous',
      beforeEnter(data) {
        if (data.next.container.querySelector('.carousel-section')) {
          $('.carousel-content').slick({
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            infinite: true,
            speed: 300,
            centerMode: true,
            variableWidth: true,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  centerMode: false,
                  arrows: true,
                },
              },
              {
                breakpoint: 640,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  centerMode: false,
                  arrows: true,
                },
              },
            ],
          });
        }
      }
    },
    {
      namespace: 'contact',
      afterEnter(data) {
        animationIconEffect(data.next.container);
      }
    }],
    transitions: [
      {
        name: 'generale-transition',
        once: ({ next }) => {
          const loaderOnLoad = document.querySelector('.loader-on-load');

          const tl = gsap.timeline();

          tl.to(next.container, { duration: 1, autoAlpha: 1 }).to(
            loaderOnLoad,
            {
              duration: 1,
              scaleY: 0, // squash the loader
              yPercent: 0, // move it down
              ease: 'Power4.inOut',
              transformOrigin: 'bottom center',
              onStart: () => animationEnterHero(next.container),
              onComplete: () => $('.top-bar-wrapper').midnight(),
            },
            '>-.5'
          );

          return tl;
        },
        afterOnce: ({ next }) => {
          ScrollTrigger.refresh('true');
          animationTitleEffect(next.container);
          animationParagraphEffect(next.container);
          animationParagraphBisEffect(next.container);
          animationListEffect(next.container);
          animationBlockquoteEffect(next.container);
        },
        async leave({ trigger }) {
          await animationLeaveCircleLoader(trigger);
        },
        beforeEnter: ({ next }) => {
          ScrollTrigger.getAll().forEach((t) => t.kill());
          ScrollTrigger.refresh('true');
          animationTitleEffect(next.container);
          animationParagraphEffect(next.container);
          animationParagraphBisEffect(next.container);
          animationListEffect(next.container);
          animationBlockquoteEffect(next.container);
        },
        enter: ({ next }) => {
          animationEnterHideCircleLoader(next.container);
          animationEnterHero(next.container);
        },
        afterEnter: () => {
          $('.top-bar-wrapper').midnight('instance').refresh();
        },
      },
    ],
  });
};

const menuEffect = () => {
  let lists = document.querySelectorAll('.off-canvas ul > li');

  [].forEach.call(lists, function (element, i) {
    i++;

    // set variables
    let duration = 0.5,
      length = -60,
      delay = i * 0.25;

    // build tween
    gsap.from(element, {
      duration: duration,
      delay: delay,
      x: length,
      autoAlpha: 0,
      ease: 'power1.out',
    });
  });
};

document.addEventListener('DOMContentLoaded', function () {
  $('.off-canvas').on('opened.zf.offcanvas', menuEffect);
});
